import particlesPackage from 'particles.js/particles';
import { $qs, $qsa } from '../../utils/QuerySelector';
import gsap from 'gsap';

function bannerServices() {

    if($qs('#particles-js-light')){
    particlesJS.load('particles-js-light', '/wp-content/themes/ciesco/src/particlesjs-config-light.json', function() { });
    }


}


export default bannerServices;